/**
 * @Description: 系统预置标签模板类别信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  IndustryAndCategoryModel,
  IndustryAndCategorySearchModel,
  IndustryAndCategoryPageSearchModel,
  IndustryAndCategoryAddModel,
  IndustryAndCategoryUpdateModel,
  IdsModel
} from '@/model/product/IndustryAndCategoryModel'

const baseUrl = Route.product + '/industryAndCategory'

/**
 * 搜索分页数据
 */
export const pageSearchIndustryAndCategory = (param: IndustryAndCategoryPageSearchModel) => {
  return https().request<RootObject<PageRespModel<IndustryAndCategoryModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchIndustryAndCategory = (param: IndustryAndCategorySearchModel) => {
  return https().request<RootObject<IndustryAndCategoryModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getIndustryAndCategory = (id: number) => {
  return https().request<RootObject<IndustryAndCategoryModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addIndustryAndCategory = (param: IndustryAndCategoryAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateIndustryAndCategory = (param: IndustryAndCategoryUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeIndustryAndCategory = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveIndustryAndCategory = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
